module.exports = new __parcel__URL__("product2.1a762b38.jpg").toString();